export default "__VITE_ASSET__xTr9YiFr__"